import _orderBy from 'lodash.orderby';

export const makeId = (length: number) => {
  var result = '';
  var characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const generateTagId = (tags: any[]) => {
  const last_tag = _orderBy(tags, (tag: any) =>
    parseInt(tag.id.split('_')[1])
  ).pop();
  if (last_tag) {
    const [_, last_id] = last_tag.id.split('_');
    return parseInt(last_id) + 1;
  } else {
    return 0;
  }
};

export const generateTrackId = (tracks: any[]) => {
  const last_track = _orderBy(
    tracks.filter((track) => track.id !== 'trackless'),
    (track: any) => parseInt(track.id.split('_')[1])
  ).pop();
  if (last_track) {
    const [_, last_id] = last_track.id.split('_');
    return parseInt(last_id) + 1;
  } else {
    return 0;
  }
};
